
    @if (!customizableMode) {
        <p-card>
        <div class="padding15">
            <div class="module-title">
                <div class="module-title-label" >Cash Report</div>
                <div (click)="showCashReport()" style="cursor:pointer"><img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg"></div>
            </div>
            @if (!data) {
                <div class='loading-spinner'></div>
            }

            @if (data) {
                <div class="module-div-includes-charts">
                    <div class="module-div-chart-wrap">
                        <p-chart type="doughnut" [data]="chartData" [options]="options" width="176px" height="176px"></p-chart>
                        <div class="module-chart-center">
                            <div class="module-chart-center-number">{{data.totalAccounts}}</div>
                            <div class="label">Accounts</div>
                        </div>
                    </div>
                    <div class="cash-module-details-panels">
                        <div>
                            <span class="cash-module-details-panel">Shortfall</span>
                            <img class="svg-arrow-right-circle" (click)="showCashReportWithCashShortFall()" src="../../assets/images/arrow-right-circle-outline.svg">
                            <div class="cash-module-details-panel-color-number" [style.color]="colors[0]">{{data.inShortFallCount}}</div>
                        </div>
                        <div>
                            <span class="cash-module-details-panel">Excess</span>
                            <img class="svg-arrow-right-circle" (click)="showCashReportWithCashInExcess()" src="../../assets/images/arrow-right-circle-outline.svg">
                            <div class="cash-module-details-panel-color-number" [style.color]="colors[1]">{{data.inExcessCount}}</div>
                        </div>
                        <div>
                            <span class="cash-module-details-panel">In Range</span>
                            <img class="svg-arrow-right-circle" (click)="showCashReportWithCashInRange()" src="../../assets/images/arrow-right-circle-outline.svg">
                            <div class="cash-module-details-panel-color-number" [style.color]="colors[2]">{{data.inRangeCount}}</div>
                        </div>
                    </div>
                </div>
            }

        </div>
        </p-card>
    }
    @if (customizableMode) {
        <div style="display: flex;flex-direction: row;height: 100%;align-items: center;padding-bottom: 15px;">
            <div style="height:176px;width: 176px;margin-left: 10px;">
                <img src="../../assets/images/donut-skeleton.svg" style="cursor: inherit!important;">
            </div>
            <div style="margin-left: 30px;width:60%;">
                <div style="display: flex;flex-direction: row;">
                    <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                    <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
                </div>
                <div class="skeleton-styles-rectangle" style="width:25%; margin-top: 5px;"></div>

                <div style="display: flex;flex-direction: row;margin-top: 10px;">
                    <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                    <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
                </div>
                <div class="skeleton-styles-rectangle" style="width:25%;margin-top: 5px;"></div>

                <div style="display: flex;flex-direction: row;margin-top: 10px;">
                    <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                    <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
                </div>
                <div class="skeleton-styles-rectangle" style="width:25%; margin-top: 5px;"></div>
            </div>
        </div>
    }

